module.exports = __webpack_public_path__ + "01_glasses_black.70f9ad5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer4/01_glasses_black.png
// module id = zKnX
// module chunks = 0